import IconConnect from '/public/icons/icon-contact-phone.svg'
import TwitterIcon from '/public/icons/icon-x.svg'
import {
  LinkedinShareButton,
  TwitterShareButton,
  FacebookShareButton
} from 'react-share'
import FacebookIcon from '/public/icons/icon-facebook.svg'
import LinkedinIcon from '/public/icons/icon-linkedin.svg'
import styles from './styles.module.scss'

const Actions = ({ blog }) => (
  <div className={styles.actions}>
    <div className={styles.actions__label}>Share</div>
    <FacebookShareButton
      url={`${typeof window !== 'undefined' && window?.location.href}
                `}
    >
      <div className={styles.actions__share}>
        <FacebookIcon width={16} height={16} />
      </div>
    </FacebookShareButton>
    <LinkedinShareButton
      url={typeof window !== 'undefined' && window.location.href}
    >
      <div className={styles.actions__share}>
        <LinkedinIcon width={16} height={16} />
      </div>
    </LinkedinShareButton>
    <TwitterShareButton
      url={typeof window !== 'undefined' && window.location.href}
      title={blog.title}
    >
      <div className={styles.actions__share}>
        <TwitterIcon width={16} height={16} />
      </div>
    </TwitterShareButton>{' '}
    <div className={styles.actions__connect}>
      Connect with Us
      <a
        rel="nofollow"
        href="tel: +1 213-805-0840"
        className={styles.actions__call}
      >
        <IconConnect />
      </a>
    </div>
  </div>
)

export default Actions
